export function parseCurrencyString(v: string): number {
  return Number.parseFloat(v.replace(/[^0-9.]/g, ''))
}
